import Vuex from 'vuex'
import Vue from 'vue'
import VuexORM from "@vuex-orm/core";

import axios from './vue-axios'
import {User} from "@/store/models/user";
import {Country} from "@/store/models/country";
import mutations from "@/store/mutations";
import modules from "./modules";
import actions from "./actions"
import Domain from "@/store/models/domain/domain";
import DomainTld from "@/store/models/domain/domain_tld";
import DomainNameserver from "@/store/models/domain/domain_nameserver";
import {DomainNameserversDomains} from "@/store/pivot/domain_nameservers_domains";
import DomainHandle from "@/store/models/domain/domain_handle";
import DomainPrice from "@/store/models/domain/domain_price";
import DomainPriceDiscount from "@/store/models/domain/domain_price_discount";
import {NameserverZone} from "@/store/models/dns/nameserver_zone";
import {GetPermissions} from "@/store/models/account/account_get_permissions";
import {BillingPositions} from "@/store/models/accounting/billing_positions";
import {Billing} from "@/store/models/accounting/billing";
import {Transactions} from "@/store/models/accounting/transactions";
import {NameserverRecords} from "@/store/models/dns/nameserver_records";
//LAYOUT
import DomainSearchResult from "@/store/models/layout/domain_search_result"
import UserConfigDefaults from "@/store/models/layout/user_config"
import PageControl from "@/store/models/layout/page_control"
import {VserverOrder} from "@/store/models/vserver/vserver_order";
import {Vserver} from "@/store/models/vserver/vserver";
import {VserverPrices} from "@/store/models/vserver/vserver_prices";
import {VserverOrderList} from "@/store/models/vserver/vserver_order_list";
import {VserverOrderErrorList} from "@/store/models/vserver/vserver_order_error_list";
import {VserverOrderResults} from "@/store/models/vserver/vserver_order_results";
import {VserverBackups} from "@/store/models/vserver/vserver_backups";
import {VserverNetworks} from "@/store/models/vserver/vserver_networks";
import {VserverIpaddresses} from "@/store/models/vserver/vserver_ipaddresses";
import {VserverScheduled} from "@/store/models/vserver/vserver_scheduled";
import {VserverGraph} from "@/store/models/vserver/vserver_graph";
import {ApiRoutesModel} from "@/store/models/layout/api_routes";

Vue.use(Vuex)
const database = new VuexORM.Database()
database.register(User)
database.register(Country)
database.register(Domain)
database.register(DomainTld)
database.register(DomainNameserver)
database.register(DomainHandle)
database.register(DomainPrice)
database.register(DomainPriceDiscount)
database.register(NameserverZone)
database.register(VserverIpaddresses)
database.register(VserverScheduled)

// LAYOUT
database.register(DomainSearchResult)
database.register(UserConfigDefaults)
database.register(PageControl)
database.register(VserverOrder)
database.register(VserverPrices)
database.register(Vserver)
database.register(VserverOrderList)
database.register(VserverOrderErrorList)
database.register(VserverOrderResults)
database.register(VserverBackups)
database.register(VserverNetworks)
database.register(VserverGraph)
database.register(ApiRoutesModel)
database.register(GetPermissions)
database.register(BillingPositions)
database.register(Billing)
database.register(Transactions)
database.register(NameserverRecords)

//Pivot models
database.register(DomainNameserversDomains)

const store = new Vuex.Store({
  namespaced: true,
  plugins: [VuexORM.install(database)],
  actions,
  modules,
  mutations,
  strict: true
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js